import { ReactNode } from 'react';
import type { CalendarProps as CalendarBaseProps } from 'react-calendar';

export interface CalendarProps {
  boxShadow?: string;
  value?: Date;
  onDateSelect: (date) => void;
  aboveNavText?: string;
  navigationPosition?: NavigationPosition;
  transform?: string;
  maxDate?: Date | null;
  minDate?: Date | null;
  maxWeek?: Date;
  minWeek?: Date;
  calendarProps?: Partial<CalendarBaseProps>;
  isBottom?: boolean;
  isTop?: boolean;
  topDate?: ReactNode;
  maxWeekNum?: number;
  showTopDate?: boolean;
  weekNum?: number;
  highlightWeekOffset?: boolean;
  weekSelect?: boolean;
  respectStartWorkWeek?: boolean;
  freezeDay?: boolean;
  showCurrWeekBar?: boolean;
  topDateType?: TopDateType;
  navHeight?: string;
  navType?: NavType;
}

export interface CurWeekBarProps {
  height: number;
}

export type NavigationPosition = 'bottom' | 'top' | 'hidden';

export enum TopDateType {
  Week = 'week',
  Full = 'full',
}

export type CalendarNavigationProps = {
  width?: string;
  height?: string;
  fullWidth?: boolean;
  position?: NavigationPosition;
  value?: Date;
  disableNext?: boolean;
  disablePrev?: boolean;
  disableNextTip?: string;
  disablePrevTip?: string;
  weekSelect?: boolean;
  onDateSelect: (date: Date) => void;
  onNavClick?: () => void;
  withCalendarIcon?: boolean;
  showYear?: boolean;
  showIcon?: boolean;
  topDateType?: TopDateType;
  formatedDate?: string;
  color?: string;
  fontSize?: string;
  navType?: NavType;
};

export enum NavType {
  Ribbon = 'ribbon',
  Default = 'default',
}

export type TimePickerValue = {
  h: number;
  m: number;
  amPm: 'am' | 'pm';
};

export type TimePickerProps = {
  pickerWidth?: string;
  pickerHeight?: string;
  value?: TimePickerValue;
  onDateSelect: (value: TimePickerValue) => void;
  minutesDelta?: number;
  minutesIncrement?: boolean;
  hideInnerBorder?: boolean;
};

export interface FormatScheduleWeekProps {
  inputDate?: string;
  isGetParams?: string;
  fSize?: string;
  fWeight?: string;
  isMobile?: boolean;
}
